import trI18n from '@/common/utils/trI18n';
import Constant from '@/common/constant/Constant';
import { useTranslationSubscription } from '@/hooks/useTranslation';

/**
 * Error line shown under an AI answer when some files generated by AI could not be saved.
 * Rendered independently of postType, because the message stays a normal message when no file could be saved.
 */
function GeneratedFileErrorMessage() {
    useTranslationSubscription();

    return (
        <div className="ai-generated-file-error">
            {`${trI18n('MSG_OPEN_AI_API_ERROR_PATH_TERM')}${Constant.AI_GENERATED_FILE_ERROR_CODE}）`}
        </div>
    );
}

export default GeneratedFileErrorMessage;
